import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import "../../../styles/Auth/settings.css";
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
const GeneralSettings = () => {
    const role = sessionStorage.getItem("role");
    const adminStoreId = sessionStorage.getItem("storeId");
    const navigate = useNavigate();
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewUrl1, setPreviewUrl1] = useState(null);
    const [companyLogo, setcompanyLogo] = useState(null);
    const [stores, setStores] = useState([]);
    const [smallLogo, setSmallLogo] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [emailError, setEmailError] = useState("");
    const [storeId, setStoreId] = useState(role === "Admin" ? adminStoreId : "");
    const [formData, setFormData] = useState(
        {
            systemTitle: "",
            companyLogo: "",
            smallLogo: "",
            timeZone: "",
            dateFormat: "",
            Currency: "",
            phoneNumber: "",
            emailAddress: "",
            ...(role === "SuperAdmin" && { storeId }),
        }
    );

    const validateEmail = (emailAddress) => {
        // Basic RFC 5322 official email regex simplified
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(emailAddress);
    };

    const handleEmailChange = (e) => {
        const emailAddress = e.target.value;
        setFormData((prev) => ({ ...prev, emailAddress }));

        if (!validateEmail(emailAddress)) {
            setEmailError("Please enter a valid email address");
        } else {
            setEmailError("");
        }
    };

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        const storedStoreId = sessionStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFormData((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);

    const handleAddSettings = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem("Token");
            const userId = sessionStorage.getItem("userId");
            if (companyLogo && userId && smallLogo) {
                const uploadCompanyLogo = await uploadFile(`files/upload/${userId}`, companyLogo);
                const uploadSmallLogo = await uploadFile(`files/upload/${userId}`, smallLogo);

                if (uploadCompanyLogo?.status === 200 && uploadSmallLogo?.status === 200) {
                    // Build the full image URL
                    const settingsData = {
                        storeId: formData.storeId,
                        systemTitle: formData.systemTitle,
                        companyLogo: uploadCompanyLogo?.data, // use uploaded file URL
                        smallLogo: uploadSmallLogo?.data,     // use uploaded file URL
                        timeZone: formData.timeZone,
                        dateFormat: formData.dateFormat,
                        Currency: formData.Currency,
                        phoneNumber: formData.phoneNumber,
                        emailAddress: formData.emailAddress,
                    };
                    console.log("Sending settings data:", settingsData);

                    const response = await postData('generalsettings/', settingsData, token);

                    toast.success(response.message || 'settings added successfully');
                    setFormData({
                        systemTitle: "",
                        companyLogo: "",
                        smallLogo: "",
                        timeZone: "",
                        dateFormat: "",
                        Currency: "",
                        phoneNumber: "",
                        emailAddress: "",
                    });
                    setcompanyLogo(null);
                    setSmallLogo(null);
                    setPreviewUrl1(null);
                    setPreviewUrl(null);
                    triggerRefresh();
                } else {
                    toast.error(uploadCompanyLogo?.message || uploadSmallLogo?.message || "Image upload failed");
                }
            }
        } catch (error) {
            console.error('Add Product Error:', error);
            toast.error(error.message || 'Add Product Failed');
        }
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };
    return (
        <div className='general-settings-layout'>
            <div className='general-settings-content'>
                <main className='general-Settings-main'>
                    <div className='general-settings-form'>
                        <h3>General Settings</h3>
                        <form className='settings-form'>
                            <div className='settings-form-row'>
                                {role === "SuperAdmin" ? (
                                    <div className="settings-form-group">
                                        <label className="input-label">Store Name</label>
                                        <select
                                            id="storeId"
                                            className="settings-input"
                                            value={formData.storeId || ""}
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, storeId: e.target.value }))
                                            }
                                        >
                                            <option value="">Select Store</option>
                                            {stores.map((store) => (
                                                <option key={store._id} value={store._id}>
                                                    {store.storeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                ) : (
                                    <input
                                        type="hidden"
                                        value={adminStoreId}
                                        readOnly
                                        name="storeId"
                                    />
                                )}
                                <div className='settings-form-group'>
                                    <label htmlFor="System Title" className="input-label">System Title</label>
                                    <input
                                        type="text"
                                        placeholder="Enter name"
                                        className="settings-input"
                                        required
                                        value={formData.systemTitle}
                                        onChange={e => setFormData(prev => ({ ...prev, systemTitle: e.target.value }))}
                                    />
                                </div>
                                <div className="settings-form-group">
                                    <label htmlFor="companylogo" className="input-label">
                                        Company Logo
                                    </label>
                                    <div className="settings-input-wrapper">
                                        <span className="settings-prefix">Upload</span>
                                        <input
                                            type="file"
                                            placeholder="Upload file"
                                            required
                                            className="settings-input1"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setcompanyLogo(file);
                                                setFormData((prev) => ({ ...prev, companyLogo: file.name }));
                                                setPreviewUrl1(URL.createObjectURL(file)); // 👈 use previewUrl1
                                            }}
                                        />
                                        {previewUrl1 && (
                                            <div className="image-preview">
                                                <img src={previewUrl1} alt="Company Logo Preview" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='settings-form-row'>
                                <div className="settings-form-group">
                                    <label htmlFor="smalllogo" className="input-label">
                                        Small Logo
                                    </label>
                                    <div className="settings-input-wrapper">
                                        <span className="settings-prefix">Upload</span>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            placeholder="Upload file"
                                            required
                                            className="settings-input1"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setSmallLogo(file);
                                                setFormData((prev) => ({ ...prev, smallLogo: file.name }));
                                                setPreviewUrl(URL.createObjectURL(file)); // 👈 use previewUrl
                                            }}
                                        />
                                        {previewUrl && (
                                            <div className="image-preview">
                                                <img src={previewUrl} alt="Small Logo Preview" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='settings-form-group'>
                                    <label className="input-label">Timezone</label>
                                    <select
                                        id="timezone"
                                        className="settings-input"
                                        required
                                        value={formData.timeZone}
                                        onChange={(e) => {
                                            const selectedTimeZone = e.target.value;
                                            setFormData((prev) => ({ ...prev, timeZone: selectedTimeZone }))
                                        }}
                                    >
                                        <option value='' >Select TimeZone</option>
                                        <option value="UTC">UTC</option>
                                        <option value="IST">India Standard Time (IST)</option>
                                        <option value="PST">Pacific Standard Time (PST)</option>
                                        <option value="EST">Eastern Standard Time (EST)</option>
                                        <option value="CET">Central European Time (CET)</option>
                                        <option value="GMT">Greenwich Mean Time (GMT)</option>
                                    </select>
                                </div>
                            </div>
                            <div className='settings-form-row'>
                                <div className='settings-form-group'>
                                    <label className="input-label">Date Format</label>
                                    <select
                                        className="settings-input"
                                        value={formData.dateFormat || "YYYY-MM-DD"} // default to "YYYY-MM-DD"
                                        onChange={(e) => setFormData((prev) => ({ ...prev, dateFormat: e.target.value }))}
                                    >
                                        <option value="YYYY-MM-DD">YYYY-MM-DD</option>
                                        <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                                        <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                                    </select>
                                </div>
                                <div className='settings-form-group'>
                                    <label className="input-label">Currency</label>
                                    <select
                                        id="currency"
                                        className="settings-input"
                                        required
                                        value={formData.Currency || ""}
                                        onChange={(e) => setFormData((prev) => ({ ...prev, Currency: e.target.value }))}
                                    >
                                        <option value="">Select Currency</option>
                                        <option value="USD">USD - United States Dollar</option>
                                        <option value="EUR">EUR - Euro</option>
                                        <option value="INR">INR - Indian Rupee</option>
                                        <option value="GBP">GBP - British Pound</option>
                                        <option value="AUD">AUD - Australian Dollar</option>
                                        <option value="JPY">JPY - Japanese Yen</option>
                                        {/* Add more currencies as needed */}
                                    </select>
                                </div>
                            </div>
                            <div className='settings-form-row'>
                                <div className='settings-form-group'>
                                    <label htmlFor="email" className="input-label">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        className="settings-input"
                                        placeholder="Enter Email"
                                        disabled={!formData.Currency}
                                        value={formData.emailAddress || ""}
                                        onChange={handleEmailChange}
                                    />
                                    {emailError && <p style={{ color: "red" }}>{emailError}</p>}
                                </div>
                                <div className='settings-form-group'>
                                    <label htmlFor="phoneNumber" className="input-label">Mobile Number</label>
                                    <input
                                        type="text"
                                        className="settings-input"
                                        placeholder="Enter Mobile Number"
                                        disabled={!formData.emailAddress}
                                        maxLength={10}
                                        title="Mobile Number must be exactly 10 digits"
                                        value={formData.phoneNumber}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Allow only digits and max 10 characters
                                            if (/^\d{0,10}$/.test(value)) {
                                                setFormData((prev) => ({ ...prev, phoneNumber: value }));
                                            }
                                        }}
                                        onBlur={() => {
                                            if (formData.phoneNumber.length !== 10) {
                                                alert("Mobile Number must be exactly 10 digits");
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="settings-buttons">
                                <button className="cancel-settings-button" >
                                    cancel
                                </button>
                                <button className="add-settings-button" type="submit" onClick={handleAddSettings} disabled={emailError !== ""} >
                                    Save Changes
                                </button>

                            </div>
                        </form>
                    </div>
                </main>
            </div>
        </div >
    );
};

export default GeneralSettings;